module.exports = __webpack_public_path__ + "img/technology-8.23b8ec68.png";